import { Linking } from 'react-native';
import type { PageConfig } from '@components/webHeader/support/pageConfig';

export const openWikiUrl = (pageConfig: PageConfig | null): void => {
  if (pageConfig?.wikiUrl) {
    Linking.openURL(pageConfig.wikiUrl);
  }
};

export const getPageDisplayName = (pageConfig: PageConfig | null): string => {
  return pageConfig?.displayName || 'Page';
};

export const hasWikiUrl = (pageConfig: PageConfig | null): boolean => {
  return !!pageConfig?.wikiUrl;
};

export const hasTourId = (pageConfig: PageConfig | null): boolean => {
  return !!pageConfig?.tourId;
};
